import { BidResponse, PostBidPayload } from '@bonhams1793/bonhams-typescript'

import { createAuthenticatedAxiosClient } from '@nx/axios-client'
import { BonhamsCookies } from '@nx/global-types'

export interface PostBidProps extends PostBidPayload {
  baseURL: string
  cookies?: BonhamsCookies
}

export async function postBid({ baseURL, cookies, ...payload }: PostBidProps) {
  const authenticatedAxiosClient = createAuthenticatedAxiosClient({
    accessTokenSSR: cookies?.bonhams_access || '',
    refreshTokenSSR: cookies?.bonhams_token || '',
    baseURL,
  })

  const response = await authenticatedAxiosClient.post<BidResponse>(
    `/api/bbe/v1/maxbids`,
    payload,
    {
      baseURL,
    }
  )

  return response.data
}
